import { useCallback, useState } from 'react'

export const useTooltip = () => {
  const [activeKey, setActiveKey] = useState(null)
  const toggleKey = useCallback((key) => {
    setActiveKey((prev) => (prev === key ? null : key))
  }, [])

  const onClose = useCallback(() => {
    setActiveKey(null)
  }, [])

  return { activeKey, toggleKey, onClose }
}